import { Time } from "roadie-ui"

Time.OMIT_LEADING_ZEROS_IN_DATES = true

declare global {
  interface Window { Time: new () => Time }
}

window.Time = Time